import { Button } from "@/components/ui/button";
import { Check } from "lucide-react";
import { useNavigate } from "react-router-dom";

const includedFeatures = [
  "Unlimited tables",
  "All views",
  "Forms",
  "5 automations",
  "n8n integration",
  "Email support",
  "Full export",
];

export const PricingSingle = () => {
  const navigate = useNavigate();

  return (
    <section className="py-16 sm:py-20 md:py-28 border-t border-border">
      <div className="container mx-auto px-4">
        <div className="max-w-xl mx-auto text-center">
          {/* Timestamp */}
          <span className="text-xs font-mono text-muted-foreground block mb-6 sm:mb-8">
            [PRICING]
          </span>
          
          {/* Price */}
          <div className="mb-6 sm:mb-8">
            <div className="text-4xl sm:text-5xl md:text-6xl font-bold mb-2">
              <span className="text-gradient">₹1,999</span>
              <span className="text-base sm:text-lg font-normal text-muted-foreground">/month</span>
            </div>
            <p className="text-sm sm:text-base text-muted-foreground">
              Per workspace. Unlimited people.
            </p>
          </div>
          
          {/* Features */}
          <div className="flex flex-wrap justify-center gap-2 sm:gap-3 mb-6 sm:mb-8 px-4">
            {includedFeatures.map((feature, idx) => (
              <div 
                key={idx}
                className="flex items-center gap-1.5 px-2.5 sm:px-3 py-1 sm:py-1.5 rounded-full bg-secondary text-xs sm:text-sm"
              >
                <Check className="h-3 w-3 sm:h-3.5 sm:w-3.5 text-terminal-text flex-shrink-0" />
                <span className="whitespace-nowrap">{feature}</span>
              </div>
            ))}
          </div>
          
          {/* Pro upsell */}
          <p className="text-xs sm:text-sm text-muted-foreground mb-6 sm:mb-8 max-w-md mx-auto px-4">
            Need more? <span className="text-foreground font-medium">Pro tier</span> unlocks unlimited automations, 
            AI agents, SSO, and 99.9% SLA for <span className="text-foreground font-medium">₹4,999/month</span>.
          </p>
          
          {/* CTAs */}
          <div className="space-y-4 px-4">
            <Button 
              size="lg"
              className="h-12 px-6 sm:px-8 text-base font-medium w-full sm:w-auto touch-target"
              onClick={() => navigate("/auth")}
            >
              Start 14-day trial
            </Button>
            <p className="text-xs sm:text-sm text-muted-foreground">
              Or use Strata{" "}
              <button 
                onClick={() => navigate("/auth")}
                className="text-foreground underline underline-offset-4 hover:text-primary transition-colors"
              >
                free forever
              </button>
              {" "}with 3 bases
            </p>
          </div>
          
          {/* Trust line */}
          <p className="text-[10px] sm:text-xs font-mono text-muted-foreground mt-6 sm:mt-8 tracking-wide px-4">
            No credit card · Full data export anytime · Self-host available
          </p>
        </div>
      </div>
    </section>
  );
};
